// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsedFooterCss_clp3o7y{font-size:14px;background-color:var(--gray00);border-top:10px solid var(--gray02);}
.mobileLegalCss_m9bhn6m{text-align:center;}
.legalBandCss_l1wyqwxh{min-height:80px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/Footer.css"],"names":[],"mappings":"AAAA,4BAA4B,cAAc,CAAC,8BAA8B,CAAC,mCAAmC,CAAC;AAC9G,wBAAwB,iBAAiB,CAAC;AAC1C,uBAAuB,eAAe,CAAC","sourcesContent":[".collapsedFooterCss_clp3o7y{font-size:14px;background-color:var(--gray00);border-top:10px solid var(--gray02);}\n.mobileLegalCss_m9bhn6m{text-align:center;}\n.legalBandCss_l1wyqwxh{min-height:80px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
